<template>
  <Drawer
    custom-class="pg-drawer-udi-scan"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :size="size"
    @close="close"
    @closed="closed"
    @opened="opened"
  >
    <div class="pg-drawer-udi-scan__content">
      <scanResult
        class="pg-drawer-udi-scan__content-result"
        ref="resultRef"
        :column="column"
        :columnTableCode="columnTableCode"
        :seachKeys="seachKeys"
        :seachPlaceholder="seachPlaceholder"
        :treeField="treeField"
        :items="items"
        :taskText="taskText"
      ></scanResult>
      <scanArea
        class="pg-drawer-udi-scan__content-area"
        :showScanAnalysisKeys="showScanAnalysisKeys"
        :formItemsCode="formItemsCode"
        :formItems="formItems"
        :getGoodsUrl="getGoodsUrl"
        :getGoodsParam="getGoodsParam"
        :scanAfter="scanAfter"
        :onConfirm="confirm"
        :setGood="setGood"
        :printScan="printScan"
        :extendData="extendData"
      ></scanArea>
      <div class="pg-drawer-udi-scan__content-footer">
        <ElButton type="primary" round :loading="loading" @click="submit"> 保存 </ElButton>
      </div>
    </div>
  </Drawer>
</template>
<script setup>
import { Drawer } from 'element-ui'
import { useDrawerPack } from '../../../hooks/index'
import { toRefs, ref } from 'vue'
import scanArea from './scan-area.vue'
import scanResult from './scan-result.vue'

const props = defineProps({
  appendToBody: {
    type: Boolean,
    default: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '扫码',
  },
  size: {
    type: [String, Number],
    default: '90%',
  },

  //上表列定义
  column: [Array, Object],
  //上表列定义code
  columnTableCode: String,
  //上表右侧支持搜索的列字段
  seachKeys: {
    type: Array,
    default: () => ['goodsDetail.code', 'goodsDetail.name', 'goodsDetail.model'],
  },
  //上表右侧支持搜索的提示语
  seachPlaceholder: {
    type: String,
    default: '搜索商品',
  },
  treeField: String,
  items: Array,
  taskText: Array,
  //额外参数
  extendData: Object,
  //扫码识别到的数据需要展示的key ['productIdent', 'batchNumber', 'periodBegin', 'periodEnd', 'periodExpire', 'serialNumber', 'amount',]
  showScanAnalysisKeys: Array,
  //扫码区域表单配置的code
  formItemsCode: String,
  //扫码区域表单配置
  formItems: [Array, Object],
  getGoodsUrl: String,
  getGoodsParam: Object,
  //扫码后的回调函数 返回的值会赋值给扫码的表单
  scanAfter: Function,
  //确认回调函数  返回 [行数据，错误提示]
  onConfirm: Function,
  //点击保存的回调函数
  onSave: Function,
  setGood: Boolean,
  printScan: Boolean,
})

const emit = defineEmits(['update:visible', 'close', 'closed', 'on-cancel', 'on-ok'])

const { visible } = toRefs(props)
const { showDrawer, close, closed, onCancel, closeDrawer } = useDrawerPack(visible, emit)

const opened = () => {
  console.log('打开侧滑')
}

const resultRef = ref(null)
const confirm = async ({ scanForm }) => {
  const scanTableData = resultRef.value.getTableData()
  const [row, errorText] = props.onConfirm
    ? await props.onConfirm?.({ scanForm, scanTableData })
    : [scanForm]
  if (errorText) {
    return errorText
  } else {
    resultRef.value.addRow(row)
  }
}

const loading = ref(false)
const submit = async () => {
  const tableData = resultRef.value.getTableData()
  if (props.onSave) {
    loading.value = true
    props.onSave?.({
      tableData,
      close: () => {
        loading.value = false
        emit('on-ok', tableData)
        closeDrawer()
      },
    })
  } else {
    emit('on-ok', tableData)
    closeDrawer()
  }
}
</script>
<style lang="scss">
@import '../style/drawer-udi-scan.scss';
</style>
